<template>
  <section class="product-components wishlist">
    <div class="container">
      <h1>{{ wish_list }}</h1>
      <p v-if="items && itemsCount > 0">
        {{ label_wishlist_intro_text_1 }}
        <a href="/where-to-buy" v-if="!is_dealer">{{ label_where_to_buy }}</a>
        {{ label_wishlist_intro_text_2 }}
      </p>
      <div v-else class="empty-wishlist-placeholder">
        <p v-html="label_empty_wishlist"></p>
        <ul v-if="!is_dealer">
          <li>
            <a href="/roof">{{ label_fit_my_vehicle }}</a>
          </li>
          <li>
            <a href="/canopy">{{ label_fit_my_canopy }}</a>
          </li>
        </ul>
      </div>

      <div v-if="items && itemsCount > 0" class="top-bar">
        <div class="counts">
          {{ itemsCount }} {{ label_items }}, {{ productsCount }}
          {{ label_products }}
        </div>
        <div class="empty-wishlist" @click="emptyWishlist()">
          {{ label_empty_wishlist_button }}
        </div>
      </div>
      <div
        v-for="(product, index) in items"
        :key="index"
        :id="'item_' + product.stockCode"
      >
        <div class="item" v-if="product.quantity > 0">
          <div class="image">
            <img width="175" :src="product.image" alt />
          </div>
          <div class="name">
            <a :href="product.url">{{ product.title }}</a>
            <div class="code">{{ product.stockCode }}</div>
          </div>
          <div class="price" v-if="hide_price_global_value == '0'">
            <div class="title">{{ label_price }}</div>
            <div class="label">{{ product.productPrice }}</div>
          </div>
          <div class="quantity">
            <input
              disabled
              type="number"
              value
              name="quantity"
              v-model="product.quantity"
            />
            <div class="title">{{ label_qty }}</div>
            <div class="label">x{{ product.quantity }}</div>
            <div class="incrementors">
              <div
                class="increase"
                :title="label_increase"
                @click="increase(product.stockCode)"
              >
                +
              </div>
              <div
                class="decrease"
                :title="label_decrease"
                @click="decrease(product.stockCode)"
              >
                &ndash;
              </div>
            </div>
          </div>
          <div class="addcart">
            <addToCartButton
              :data="{
                class: 'btn-primary',
                stockCode: product.stockCode,
                netSuiteId: product.netSuiteId,
                netSuiteParentId: product.netSuiteParentId,
                productId: product.productId,
                quantity: product.quantity,
                hideCartButton: product.hideCartButton,
                isAlwaysInStock: product.isAlwaysInStock,
              }"
              :items="product.components"
              :label_added_to_cart="added_to_cart"
              :label_add_to_cart="add_to_cart"
              :enable_b2c="enable_b2c"
              :enable_b2b="enable_b2b"
              :label_adding_to_cart="label_adding_to_cart"
              :label_view_cart="label_view_cart"
              :label_continue_shopping="label_continue_shopping"
              :label_find_a_dealer="label_find_a_dealer"
              :netsuite_url="netsuite_url"
              :netsuite_app_url="netsuite_app_url"
              :is_spare_part_enabled="is_spare_part_enabled"
              @removeFromWishlist="removeFromWishlist"
            ></addToCartButton>
          </div>
          <div class="cart">
            <i
              @click="remove(product.stockCode, 0)"
              class="icon icon-close"
            ></i>
          </div>
        </div>

        <product-component
          :items="product.components"
          v-if="product.quantity > 0 && product.components.length"
          :currency_suffix="currency_suffix"
          :label_total="label_total"
          :label_price="label_price"
          :label_qty="label_qty"
          :label_included_parts="label_included_parts"
          :label_find_a_dealer="label_find_a_dealer"
        ></product-component>
      </div>
      <div class="clearfix"></div>
    </div>

    <form
      v-if="items && itemsCount > 0"
      id="email-wishlist"
      method="post"
      class="container"
    >
      <div class="form">
        <div class="form-content row">
          <div class="form-row col-md-6 md-display-none"></div>
          <div class="form-row col-md-6 next-step">
            <div class="next-step-heading">{{ label_next_step }}:</div>
            <select
              name
              :id="email_method"
              v-model="email_method"
              dusk="email_method"
              :disabled="email_sending || email_sent"
            >
              <option value="default">-- Select step --</option>
              <option
                v-if="this.is_dealer == 0 && enable_wishlist == '1'"
                value="email_dealer"
              >
                {{ this.request_quote_from_dealer }}
              </option>
              <option value="email_wishlist">
                {{ this.email_me_my_wishlist }}
              </option>
            </select>
            <button
              @click.prevent="selectMailMethod()"
              class="btn btn-hover pull-right btn-primary"
              :disabled="email_sending || email_sent"
            >
              {{ label_go }}
            </button>
          </div>
        </div>
        <div
          class="form-content row form-body"
          v-if="method_selected && email_method === 'email_dealer'"
        >
          <div class="form-row col-md-6">
            <label>{{ label_first_name }}*</label>
            <br />
            <input
              id="first_name"
              type="text"
              v-model.trim.lazy="$v.form.first_name.$model"
            />
            <p
              class="error"
              v-if="$v.form.email.$dirty && !$v.form.first_name.required"
            >
              {{ label_required }}
            </p>
          </div>
          <div class="form-row col-md-6">
            <label>{{ label_last_name }}*</label>
            <br />
            <input
              id="last_name"
              type="email"
              v-model.trim.lazy="$v.form.last_name.$model"
            />
            <p
              class="error"
              v-if="$v.form.last_name.$dirty && !$v.form.last_name.required"
            >
              {{ label_required }}
            </p>
          </div>
          <div class="form-row col-md-6">
            <label>{{ label_email }}*</label>
            <br />
            <input
              id="email"
              type="email"
              v-model.trim.lazy="$v.form.email.$model"
            />
            <p
              class="error"
              v-if="$v.form.email.$dirty && !$v.form.email.required"
            >
              {{ label_required }}
            </p>
            <p class="error" v-if="!$v.form.email.email">{{ label_invalid }}</p>
          </div>
          <div class="form-row col-md-6">
            <label>{{ label_mobile }}*</label>
            <br />
            <input
              id="mobile"
              type="text"
              v-model.trim.lazy="$v.form.mobile.$model"
            />
            <p
              class="error"
              v-if="$v.form.mobile.$dirty && !$v.form.mobile.required"
            >
              {{ label_required }}
            </p>
          </div>

          <div class="form-row col-md-6">
            <label>{{ label_quote_details }}*</label>
            <br />

            <select
              name
              id="quote_details"
              v-model.trim.lazy="$v.form.quote_details.$model"
              dusk="quote_details"
              @change="toggleServiceTypes()"
            >
              <option value="">{{ this.label_wishlist_please_select }}</option>
              <option value="label_wishlist_include_full_dealer_information">
                {{ this.label_wishlist_include_full_dealer_installation }}
              </option>
              <option value="label_wishlist_pickup_products_instore">
                {{ this.label_wishlist_pickup_products_instore }}
              </option>
              <option value="label_wishlist_deliver_to_my_address">
                {{ this.label_wishlist_deliver_to_my_address }}
              </option>
            </select>
            <p
              class="error"
              v-if="
                $v.form.quote_details.$dirty && !$v.form.quote_details.required
              "
            >
              {{ label_required }}
            </p>

            <div id="fitting_row" v-if="false">
              <h6>{{ label_service_types }}</h6>

              <div class="fitting">
                <input
                  id="general_fitting"
                  value="general_fitting"
                  type="checkbox"
                  v-model="fitting_types"
                />
                <label for="general_fitting">{{ label_general_fitting }}</label>
              </div>
              <div class="fitting">
                <input
                  id="specialist_fitting"
                  value="specialist_fitting"
                  type="checkbox"
                  v-model="fitting_types"
                />
                <label for="specialist_fitting">{{
                  label_specialist_fitting
                }}</label>
              </div>
            </div>
          </div>

          <div class="form-row col-md-6">
            <label>{{ label_select_your_nearest_prefered_dealer }}*</label>
            <store-locator-wishlist
              v-on:storeSelected="storeSelected($event)"
              :placeholder="labels_search_by_suburb_or_postcode"
              :search="label_search"
              :refine="label_refine"
              :distance="label_distance"
              :location="label_location"
              :stores_within="label_stores_within"
              :refine_your_search="label_refine_your_search"
              :no_phone_number="label_no_phone_number"
              :learn_more="label_learn_more"
              :stocks="label_stocks"
              :services="label_services"
              :filter_by_stock_type="label_filter_by_stock_type"
              :filter_by_services="label_filter_by_services"
              :empty_result="empty_result"
              :fitting_types="fitting_types"
            ></store-locator-wishlist>
            <p class="error" v-if="select_store_required">
              {{ label_required }}
            </p>
          </div>

          <div class="form-row col-md-6" v-if="hide_wishlist_subscribe == '0'">
            <div class="subscribe">
              <input
                id="subscribe"
                type="checkbox"
                v-model.trim.lazy="form.subscribe"
              />
              <label for="subscribe">{{ label_subscribe }}</label>
            </div>
          </div>
          <div class="form-row col-md-12 button-col"></div>
          <div class="form-row col-md-6">
            <vue-recaptcha
              v-if="method_selected"
              :sitekey="sitekey"
              :loadRecaptchaScript="true"
              @error="error"
              @expired="expired"
              @verify="verify"
            ></vue-recaptcha>
          </div>
          <div class="form-row col-md-6 button-col"></div>
          <div class="col-12">
            <sub
              >By submitting a wish list request you are agreeing to receive
              Rhino-Rack email communications. You can opt-out at any time.</sub
            ><br /><br />
          </div>
          <div class="form-row col-md-6 button-col">
            <button
              @click.prevent="wishlistemail()"
              :disabled="
                email_sending || (verified === true && !email_sent)
                  ? false
                  : true
              "
              class="btn btn-hover pull-right btn-primary"
            >
              {{ this.label_request_quote }}
            </button>
            <p
              v-if="email_sent"
              class="email-success-message"
              style="text-align: right"
            >
              {{ this.email_wishlist_success }}
            </p>
          </div>
        </div>

        <div
          class="form-content row form-body"
          v-if="method_selected && email_method === 'email_wishlist'"
        >
          <div class="form-row col-md-6">
            <label>{{ label_first_name }}*</label>
            <br />
            <input
              id="first_name"
              type="text"
              v-model.trim.lazy="$v.form.first_name.$model"
            />
            <p
              class="error"
              v-if="$v.form.email.$dirty && !$v.form.first_name.required"
            >
              {{ label_required }}
            </p>
          </div>
          <div class="form-row col-md-6">
            <label>{{ label_last_name }}*</label>
            <br />
            <input
              id="last_name"
              type="email"
              v-model.trim.lazy="$v.form.last_name.$model"
            />
            <p
              class="error"
              v-if="$v.form.last_name.$dirty && !$v.form.last_name.required"
            >
              {{ label_required }}
            </p>
          </div>
          <div class="form-row col-md-6">
            <label>{{ label_email }}*</label>
            <br />
            <input
              id="email"
              type="email"
              v-model.trim.lazy="$v.form.email.$model"
            />
            <p
              class="error"
              v-if="$v.form.email.$dirty && !$v.form.email.required"
            >
              {{ label_required }}
            </p>
            <p class="error" v-if="!$v.form.email.email">{{ label_invalid }}</p>
          </div>
          <div class="form-row col-md-6">
            <label>{{ label_mobile }}*</label>
            <br />
            <input
              id="mobile"
              type="text"
              v-model.trim.lazy="$v.form.mobile.$model"
            />
            <p
              class="error"
              v-if="$v.form.mobile.$dirty && !$v.form.mobile.required"
            >
              {{ label_required }}
            </p>
          </div>
          <div class="form-row col-md-12 button-col"></div>
          <div class="form-row col-md-6">
            <vue-recaptcha
              v-if="method_selected"
              :sitekey="sitekey"
              :loadRecaptchaScript="true"
              @error="error"
              @expired="expired"
              @verify="verify"
            ></vue-recaptcha>
          </div>
          <div class="form-row col-md-6 button-col"></div>
          <div class="col-12">
            <sub
              >By submitting a wish list request you are agreeing to receive
              Rhino-Rack email communications. You can opt-out at any time.</sub
            ><br /><br />
          </div>
          <div class="form-row col-md-6 button-col">
            <button
              @click.prevent="wishlistemail()"
              :disabled="
                email_sending || (verified === true && !email_sent)
                  ? false
                  : true
              "
              class="btn btn-hover pull-right btn-primary"
            >
              {{ this.label_send_wish_list }}
            </button>
            <p
              v-if="email_sent"
              class="email-success-message"
              style="text-align: right"
            >
              {{ this.email_wishlist_success }}
            </p>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Vue from "vue";
import productComponent from "./product-component.vue";
import addToCartButton from "../cart/add-to-cart-standalone.vue";
import { required, email, requiredIf } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";

function startsWith(wordToCompare) {
  return function (element) {
    return element.indexOf(wordToCompare) === 0;
  };
}
export default {
  name: "wishlist-list",
  components: { VueRecaptcha: VueRecaptcha },
  validations() {
    if (this.email_method == "email_dealer") {
      return {
        form: {
          email: {
            required,
            email,
          },
          first_name: {
            required,
          },
          last_name: {
            required,
          },
          mobile: {
            required,
          },
          quote_details: {
            required,
          },
        },
      };
    }

    return {
      form: {
        email: {
          required,
          email,
        },
        first_name: {
          required,
        },
        last_name: {
          required,
        },
        mobile: {
          required,
        },
      },
    };
  },
  props: {
    sitekey: {
      type: String,
      required: true,
    },
    currency_suffix: {
      type: String,
      default: "",
    },
    currency_symbol: {
      type: String,
      default: "$",
    },
    wish_list: {
      type: String,
      required: true,
      default: "Wish List",
    },
    label_empty_wishlist: {
      type: String,
      required: true,
      default:
        "Your wishlist is empty. You can use the following tools to find items that are perfect for your vehicle:",
    },
    label_increase: {
      type: String,
      required: true,
      default: "Increase",
    },
    label_decrease: {
      type: String,
      required: true,
      default: "Decrease",
    },
    label_remove: {
      type: String,
      required: true,
      default: "Remove",
    },
    label_total: {
      type: String,
      required: true,
      default: "Total",
    },
    label_price: {
      type: String,
      required: true,
      default: "Price",
    },
    label_qty: {
      type: String,
      required: true,
      default: "Qty",
    },
    label_subscribe: {
      type: String,
      required: true,
      default: "Please sign me up for Rhino-Rack email communications",
    },
    label_wishlist_intro_text_1: {
      type: String,
      required: true,
      default:
        "You have added the following items to your wishlist. You can print this and take it with you to your nearest Rhino-Rack dealer. You can use our",
    },
    label_wishlist_intro_text_2: {
      type: String,
      required: true,
      default: "section on the website to find your nearest store.",
    },
    label_where_to_buy: {
      type: String,
      required: true,
      default: "Where to Buy",
    },
    label_included_parts: {
      type: String,
      required: true,
      default: "included parts",
    },
    label_email: {
      type: String,
      required: true,
      default: "Email",
    },
    label_first_name: {
      type: String,
      required: true,
      default: "First Name",
    },
    label_last_name: {
      type: String,
      required: true,
      default: "Surname",
    },
    label_mobile: {
      type: String,
      required: true,
      default: "Mobile",
    },
    label_quote_details: {
      type: String,
      required: true,
      default: "Additional Quote Details",
    },
    label_wishlist_please_select: {
      type: String,
      required: true,
      default: "Please select",
    },
    label_required: {
      type: String,
      required: true,
      default: "Required",
    },
    label_invalid: {
      type: String,
      required: true,
      default: "Invalid",
    },
    label_go: {
      type: String,
      required: true,
      default: "Go",
    },
    label_general_fitting: {
      type: String,
      default: "General Fitting",
    },
    label_specialist_fitting: {
      type: String,
      default: "Specialist Fitting",
    },
    label_service_types: {
      type: String,
      default: "Service Types Fitting",
    },
    labels_search_by_suburb_or_postcode: {
      type: String,
      required: true,
      default: "Search by suburb or postcode",
    },
    request_quote_from_dealer: {
      type: String,
      required: true,
      default: "Request a quote from a dealer",
    },
    email_me_my_wishlist: {
      type: String,
      required: true,
      default: "Email Me My Wish List",
    },
    label_send_wish_list: {
      type: String,
      required: true,
      default: "Send Wishlist",
    },
    label_quote_details: {
      type: String,
      required: true,
      default: "Quote Details",
    },
    label_request_quote: {
      type: String,
      required: true,
      default: "Request Quote",
    },
    email_wishlist_success: {
      type: String,
      required: true,
      default: "Your email has been sent",
    },
    label_select_your_nearest_prefered_dealer: {
      type: String,
      required: true,
      default: "Select Your Nearest/Preferred Dealer",
    },
    label_wishlist_include_full_dealer_installation: {
      type: String,
      required: true,
      default: "Full Dealer Installation Required",
    },
    label_wishlist_pickup_products_instore: {
      type: String,
      required: true,
      default: "No Installation - Pick Up Products In Store",
    },
    label_wishlist_deliver_to_my_address: {
      type: String,
      required: true,
      default: "No Installation - Deliver To My Address",
    },
    label_items: {
      type: String,
      required: true,
      default: "items",
    },
    label_products: {
      type: String,
      required: true,
      default: "products",
    },
    label_fit_my_vehicle: {
      type: String,
      required: true,
      default: "Fit my Vehicle",
    },
    label_fit_my_canopy: {
      type: String,
      required: true,
      default: "Fit my Canopy",
    },
    label_qty: {
      type: String,
      required: true,
      default: "Qty",
    },
    label_next_step: {
      type: String,
      required: true,
      default: "Next Step",
    },
    label_empty_wishlist_button: {
      type: String,
      required: true,
      default: "Empty Wishlist",
    },
    label_search: {
      type: String,
      required: true,
      default: "Search",
    },
    label_refine: {
      type: String,
      required: true,
      default: "Refine your search",
    },
    label_distance: {
      type: String,
      required: true,
      default: "Distance",
    },
    label_location: {
      type: String,
      required: true,
      default: "Location",
    },
    label_stores_within: {
      type: String,
      required: true,
      default: "stores within",
    },
    label_refine_your_search: {
      type: String,
      required: true,
      default: "Refine your search",
    },
    label_no_phone_number: {
      type: String,
      required: true,
      default: "No Phone Number",
    },
    label_learn_more: {
      type: String,
      required: true,
      default: "Learn More",
    },
    label_stocks: {
      type: String,
      required: true,
      default: "Stocks",
    },
    label_services: {
      type: String,
      required: true,
      default: "Services",
    },
    label_filter_by_stock_type: {
      type: String,
      required: true,
      default: "Filter by Stock Type",
    },
    label_filter_by_services: {
      type: String,
      required: true,
      default: "Filter by Services",
    },
    enable_b2c: {
      type: String,
      required: true,
      default: "0",
    },
    enable_b2b: {
      type: String,
      required: true,
      default: "0",
    },
    netsuite_url: {
      type: String,
      required: true,
      default: "",
    },
    netsuite_app_url: {
      type: String,
      required: true,
      default: "",
    },
    add_to_cart: {
      type: String,
      required: true,
      default: "Add to cart",
    },
    added_to_cart: {
      type: String,
      required: true,
    },
    add_to_wishlist: {
      type: String,
      required: true,
      default: "Add to wishlist",
    },
    label_adding_to_cart: {
      type: String,
      required: true,
      default: "Adding to Cart",
    },
    label_view_cart: {
      type: String,
      required: true,
      default: "View Cart",
    },
    label_continue_shopping: {
      type: String,
      required: true,
      default: "Continue Shopping",
    },
    label_find_a_dealer: {
      type: String,
      required: true,
      default: "Find a Dealer",
    },
    is_dealer: {
      type: String,
      required: true,
    },
    enable_wishlist: {
      type: String,
      required: true,
      default: "1",
    },
    empty_result: {
      type: String,
      default: "Result is empty",
    },
    hide_price_global_value: {
      type: String,
      default: "0",
    },
    hide_wishlist_subscribe: {
      type: String,
      default: "1",
    },
    ga_tracking_category: {
      type: String,
      default: "WishList",
    },
    ga_tracking_action: {
      type: String,
      default: "Click",
    },
    is_spare_part_enabled: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      items: [],
      verified: false,
      verified_token: "",
      //email_method: this.is_dealer == 1  ?  "email_wishlist" : "email_dealer",
      email_method: "default",
      method_selected: false,
      email_sending: false,
      email_sent: false,
      select_store_required: false,
      fitting_types: [],
      form: {
        email: "",
        first_name: "",
        last_name: "",
        mobile: "",
        subscribe: false,
        quote_details: "",
        selectedStore: null,
      },
    };
  },
  components: {
    productComponent,
    addToCartButton,
  },
  mounted() {
    this.triggerGA();
    let baseUrl = "api/products";
    let wishListArr = [...this.$store.state.wishlist.list];

    axios
      .post(`${baseUrl}`, { products: wishListArr })
      .then((response) => {
        this.items = response.data.data;

        for (var i = 0; i < this.items.length; i++) {
          this.items[i].quantity = wishListArr.filter(
            startsWith(this.items[i].stockCode)
          ).length;
        }

        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].components.length) {
            for (var j = 0; j < this.items[i].components.length; j++) {
              Vue.set(
                this.items[i].components[j],
                "quantity",
                this.items[i].components[j].quantity * this.items[i].quantity
              );
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error: ", error);
      });
  },
  methods: {
    toggleServiceTypes() {
      if (
        this.form.quote_details ==
        "label_wishlist_include_full_dealer_information"
      ) {
        this.fitting_types = ["specialist_fitting"];
      } else {
        this.fitting_types = [];
      }
    },
    selectMailMethod() {
      this.method_selected = true;
      ga(
        "send",
        "event",
        this.ga_tracking_category,
        "Go Button - " + this.email_method
      );
      gtag('event', this.ga_tracking_category + '_' + this.email_method, {'category':'Wishlist', 'action':"Go Button - " + this.email_method});
    },
    storeSelected(store) {
      this.form.selectedStore = store;
    },
    expired(value) {
      this.verified = false;
    },
    verify(value) {
      this.verified_token = value;
      this.verified = true;
    },
    error(value) {
      this.verified = false;
    },
    currencyFormat(num) {
      return num;
    },
    increase(stockCode) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].stockCode == stockCode) {
          Vue.set(this.items[i], "quantity", this.items[i].quantity + 1);
          this.$store.commit("wishlist/addItem", this.items[i].stockCode);
          if (this.items[i].components.length) {
            for (var j = 0; j < this.items[i].components.length; j++) {
              Vue.set(
                this.items[i].components[j],
                "quantity",
                this.items[i].components[j].quantity_const *
                  this.items[i].quantity
              );
            }
          }
        }
      }
    },
    decrease(stockCode) {
      for (var i = 0; i < this.items.length; i++) {
        if (
          this.items[i].stockCode == stockCode &&
          this.items[i].quantity > 1
        ) {
          Vue.set(this.items[i], "quantity", this.items[i].quantity - 1);
          this.$store.commit("wishlist/removeItem", this.items[i].stockCode);
          if (this.items[i].components.length) {
            for (var j = 0; j < this.items[i].components.length; j++) {
              Vue.set(
                this.items[i].components[j],
                "quantity",
                this.items[i].components[j].quantity_const *
                  this.items[i].quantity
              );
            }
          }
        }
      }
    },
    remove(stockCode, timeout = 500) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].stockCode == stockCode) {
          this.$store.commit("wishlist/clear", this.items[i].stockCode);

          setTimeout(function () {
            $("#item_" + stockCode).fadeOut("slow", function () {});
          }, timeout);

          // this.items = this.items.filter(function( obj ) {
          //     return obj.stockCode !== stockCode;
          // });
        }
      }
    },
    removeFromWishlist(stockCode) {
      this.remove(stockCode);
    },
    emptyWishlist() {
      var stockCodes = [];
      for (var i = 0; i < this.items.length; i++) {
        stockCodes.push(this.items[i].stockCode);
      }
      for (var i = 0; i < stockCodes.length; i++) {
        this.remove(stockCodes[i]);
      }
    },
    async wishlistemail() {
      if (this.verified === true && this.$v.$invalid === false) {
        this.$v.form.$touch();

        if (this.$v.form.$pending || this.$v.form.$error) {
          return;
        }

        if (this.form.selectedStore === null && this.isDealerForm === true) {
          this.select_store_required = true;
          return;
        }

        this.email_sending = true;

        this.form.items = this.items;
        this.form.email_method = this.email_method;
        this.form.token = this.verified_token;
        ga(
          "send",
          "event",
          this.ga_tracking_category,
          "Request Quote - " + this.email_method
        );
        gtag('event', this.ga_tracking_category + '_' + this.email_method, {'category':'Wishlist', 'action':"Request Quote " + this.email_method});
        // to form submit after this
        let response = await axios.post(`api/wishlistemail`, this.form);

        if (response.data.data === true && response.data.success === true) {
          this.email_sending = false;
          this.email_sent = true;
          return;
        }

        this.email_sending = false;
        this.email_sent = true;
        return;
      }
    },
    triggerGA() {
      setTimeout(()=>{
        gtag('event', 'view_wishlist', {'category':'Wishlist', 'action':'Wishlist', 'value': 'view wishlist'});
      }, 500);
    },
  },
  computed: {
    isDealerForm() {
      return this.email_method === "email_dealer";
    },
    isWishlistForm() {
      return this.email_method === "email_wishlist";
    },
    itemsCount() {
      var counts = {};
      for (var i = 0; i < this.$store.state.wishlist.list.length; i++) {
        counts[this.$store.state.wishlist.list[i]] =
          1 + (counts[this.$store.state.wishlist.list[i]] || 0);
      }
      return Object.keys(counts).length;
    },
    productsCount() {
      return this.$store.state.wishlist.list.length;
    },
  },
};
</script>

<style>
.fitting input[type="checkbox"] {
  height: 20px;
  width: 20px;
}
.fitting label {
  position: relative;
  top: -5px;
}

.subscribe input[type="checkbox"] {
  opacity: 0;
}

.subscribe label {
  position: relative;
  display: inline-block;

  /*16px width of fake checkbox + 6px distance between fake checkbox and text*/
  padding-left: 22px;
}

.subscribe label::before,
.subscribe label::after {
  position: absolute;
  content: "";

  /*Needed for the line-height to take effect*/
  display: inline-block;
}

/*Outer box of the fake checkbox*/
.subscribe label::before {
  height: 16px;
  width: 16px;

  border: 1px solid #eaeaea;
  left: 0px;

  /*(24px line-height - 16px height of fake checkbox) / 2 - 1px for the border
     *to vertically center it.
     */
  top: 3px;
}

/*Checkmark of the fake checkbox*/
.subscribe label::after {
  height: 5px;
  width: 9px;
  border-left: 2px solid;
  border-bottom: 2px solid;

  transform: rotate(-45deg);

  left: 4px;
  top: 7px;
}

/*Hide the checkmark by default*/
.subscribe input[type="checkbox"] + label::after {
  content: none;
}

/*Unhide on the checked state*/
.subscribe input[type="checkbox"]:checked + label::after {
  content: "";
}

.email-success-message {
  padding-bottom: 40px;
}

#fitting_row {
  /* border: solid 1px #000; */
}
</style>
